<template>
  <d-tabs v-model="selectedGroup" ref="tabs" class="groups-tab">
    <d-tab :title="group.name" class="p-3" v-for="(group, index) in model" :key="index">
      <d-row>
        <!-- Nome -->
        <d-col md="8" class="form-group">
          <label for="name">
            Etiqueta
          </label>
          <d-form-input
            type="text"
            id="fename"
            placeholder="Nome"
            v-model="group.name"
            :state="hasError(group, 'name')"
          />
          <d-form-invalid-feedback>Etiqueta é obrigatório</d-form-invalid-feedback>
        </d-col>
        <d-col md="4" class="form-group text-right d-flex justify-content-end align-items-end">
          <label class="d-block p-2"></label>
          <d-button-group class="buttons">
            <d-button type="button" size="sm" class="btn-success" @click.prevent="addTab()">
              <i class="fas fa-plus"></i><span class="d-none d-lg-inline"> Adicionar Aba</span>
            </d-button>
            <d-button type="button" size="sm" class="btn-secondary" @click.prevent="duplicateTab(index)">
              <i class="fas fa-copy"></i><span class="d-none d-lg-inline"> Duplicar Aba</span>
            </d-button>
            <d-button type="button" size="sm" class="btn-danger" @click.prevent="confirmDeleteTab(index)">
              <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar Aba</span>
            </d-button>
          </d-button-group>
        </d-col>
      </d-row>

      <!-- Product Table -->
      <d-form-row class="mt-4 mb-4 justify-content-end">
        <table class="table table-striped table-bordered" role="table">
          <thead class="bg-light" role="rowgroup">
            <tr role="row">
              <th role="columnheader" class="text-center">ID</th>
              <th role="columnheader">Descrição produto</th>
              <th role="columnheader" class="text-center text-nowrap th-presentation">
                 <span class="mr-2">Img.</span>
                <button
                  type="button"
                  class="fas fa-image th-show-image-toggle"
                  :id="'tooltip-show-image-' + index"
                  :class="{ 'is-active': areAllShowImagesEnabled(group) }"
                  :disabled="!hasAnyProductImage(group)"
                  @click="toggleAllShowImages(group)"
                ></button>
                <d-tooltip :target="'#tooltip-show-image-' + index">
                  <span class="font-weight-bold">Exibir imagens dos produtos no orçamento.</span><br>
                  Clique no ícone para ativar ou desativar a exibição de todos os produtos.
                </d-tooltip>
              </th>
              <th role="columnheader">Garantia</th>
              <th role="columnheader" class="text-center">Unid.</th>
              <th role="columnheader" class="text-center">Qtd.</th>
              <th role="columnheader" class="text-right">Valor un.</th>
              <th role="columnheader" class="text-right">Total</th>
              <th role="columnheader" class="text-right"></th>
            </tr>
          </thead>
          <draggable
            v-model="group.rows"
            tag="tbody"
            ghost-class="ghost"
            draggable=".draggable-item"
            @end="setProductInAutocomplete"
          >
            <tr
              role="row"
              v-for="(item, navItemId) in group.rows"
              :key="navItemId"
              class="drag-row draggable-item"
            >
              <td role="cell" class="td-1">
                <span class="d-block mt-2 text-center">{{navItemId + 1}}</span>
              </td>
              <td role="cell" class="td-4">
                <autocomplete
                  :ref="`autocompleteProduct_${index}${navItemId}`"
                  :state="state"
                  placeholder="Produto"
                  :items="products"
                  item-show="name"
                  :parameter="{item, index}"
                  :on-input="(name) => onInputProduct(name, activePriceTable)"
                  :on-select="setProductQuotationRow"
                  :on-blur="setDescriptionQuotationRow"
                ></autocomplete>
                <d-form-invalid-feedback>Pelo menos um produto é obrigatório</d-form-invalid-feedback>
              </td>
              <td role="cell" class="td-1 td-presentation text-center">
                <d-checkbox
                  toggle
                  :checked="item.show_image"
                  @change="toggleShowImage(item)"
                  class="custom-toggle-sm"
                  :class="{ 'custom-toggle-disabled': !hasProductImage(item) }"
                  :disabled="!hasProductImage(item)"
                ></d-checkbox>
              </td>
              <td role="cell" class="td-2">
                <InputWarranty :warranty.sync="item.warranty_period" :warrantyTypeId.sync="item.warranty_type"/>
              </td>
              <td role="cell" class="td-2">
                <d-select
                  v-model="item.unit_type"
                  :options="productUnits"
                  value-field="name"
                  text-field="name"
                  @change="changeStep(item)"
                >
                </d-select>
              </td>
              <td role="cell" class="td-2">
                <input
                  type="number"
                  class="text-center form-control"
                  :step="item.step"
                  placeholder="Qtd."
                  v-model="item.quantity"
                  @change="setTotal(item, index)"
                  required
                />
              </td>
              <td role="cell" class="td-2">
                <d-input-group prepend="R$">
                  <input-currency
                    model-index="value"
                    placeholder="Valor"
                    :parameter="index"
                    :model="item"
                    :on-change="setTotal"
                  ></input-currency>
                </d-input-group>
              </td>
              <td role="cell" class="td-3">
                <d-input-group prepend="R$">
                  <input-currency
                    model-index="total"
                    placeholder="Total"
                    :parameter="index"
                    :model="item"
                    :on-change="setUnitValor"
                  ></input-currency>
                </d-input-group>
              </td>
              <td role="cell" class="td-1 buttons">
                <i class="fas fa-minus text-danger" @click="removeRow(index, navItemId)" v-if="group.rows.length > 1"></i>
              </td>
            </tr>
          </draggable>
        </table>
        <button type="button" @click="addRow(index)" class="btn btn-success"><i class="fas fa-plus text-white"></i> Novo item</button>
      </d-form-row>

      <d-form-row class="justify-content-end">

        <!-- Subtotal -->
        <d-col md="12" lg="4" xl="2" cols="12" class="form-group">
          <label for="feSubtotal">Subtotal</label>
          <d-input-group prepend="R$">
            <input-currency
              model-index="subtotal"
              placeholder="Subotal"
              :parameter="index"
              :model="group"
              :on-change="setUnitValor"
              readonly
            ></input-currency>
          </d-input-group>
        </d-col>

        <!-- Desconto -->
        <d-col md="12" lg="4" xl="2" cols="12" class="form-group mb-0">
          <label for="feDesconto">Desconto</label>
          <d-input-group class="mb-3 discount">
            <d-input-group-addon prepend>
              <select class="input-group-text form-control custom-select" v-model="group.discount_type" @change="setQuotationTotal(null, index)">
                <option value="pct" selected>%</option>
                <option value="value">R$</option>
              </select>
            </d-input-group-addon>
            <input-currency
              model-index="discount"
              placeholder="Desconto"
              hiddenGroup=""
              :parameter="index"
              :model="group"
              :on-change="setQuotationTotal"
            ></input-currency>
          </d-input-group>
        </d-col>

        <!-- Total -->
        <d-col md="12" lg="4" xl="2" cols="12" class="form-group">
          <label for="feTotal">Total</label>
          <d-input-group prepend="R$">
            <input-currency
              model-index="total"
              placeholder="Total"
              :parameter="index"
              :model="group"
              :on-change="setQuotationDiscount"
              :state="hasError(group, 'total')"
            ></input-currency>
            <d-form-invalid-feedback>Total é obrigatório</d-form-invalid-feedback>
          </d-input-group>
        </d-col>

      </d-form-row>

      <!-- Show payment spot-->
      <d-form-row class="justify-content-end">
        <d-col cols="6" class="form-group text-rigth">
          <d-form-row  class="justify-content-end">
            <label class="mr-3">Exibir pagamento à vista parcelado</label>
            <d-checkbox toggle @change="togglePaymentSpot(index)" :checked="group.payment_spot == 1" class="custom-toggle-sm mr-2">Sim</d-checkbox>
          </d-form-row>
        </d-col>
      </d-form-row>

      <!-- If payment has spot payment_type -->
      <d-form-row class="justify-content-end" v-if="group.payment_spot == 1 && group.installments_by_types.spot">
        <d-col lg="9" xl="7" cols="12" class="form-group">
          <d-card class="pb-2">
            <d-card-header>
              <h6 class="m-0">Valor à vista parcelado</h6>
            </d-card-header>
            <d-form-row class="px-3 justify-content-end">
              <!-- Quantidade de parcelas -->
              <d-col md="3" cols="12" class="form-group mb-0">
                <label for="feEntree">Entrada</label>
                <d-input-group class="mb-2 discount">
                  <d-input-group-addon prepend>
                    <select
                      class="input-group-text form-control custom-select"
                      v-model="group.installments_by_types.spot[0].entree_type"
                      @change="setParcelValue(group.installments_by_types.spot[0], index)"
                    >
                      <option value="pct" selected>%</option>
                      <option value="value">R$</option>
                    </select>
                  </d-input-group-addon>
                  <input-currency
                    model-index="entree_value"
                    placeholder="Entrada"
                    hiddenGroup=""
                    :parameter="index"
                    :model="group.installments_by_types.spot[0]"
                    :on-change="setParcelValue"
                  ></input-currency>
                </d-input-group>
              </d-col>

              <!-- Quantidade de parcelas -->
              <d-col md="2" cols="12" class="form-group mb-0">
                <label for="fePagto">Parcelas</label>
                <d-form-input
                  type="number"
                  id="fePagto"
                  class="text-right"
                  min="1"
                  v-model="group.installments_by_types.spot[0].parcel"
                  @input="setParcelValue(group.installments_by_types.spot[0], index)"
                  @change="setParcelValue(group.installments_by_types.spot[0], index, true)"
                />
              </d-col>

              <!-- Valor da parcela -->
              <d-col md="3" cols="12" class="form-group mb-0">
                <label for="feParcela">Valor da parcela</label>
                <d-input-group prepend="R$">
                  <input-currency
                    v-if="group.installments_by_types.spot && group.installments_by_types.spot[0] && group.installments_by_types.spot[0].parcel_value"
                    :key="'spot-pv-' + index + '-' + group.installments_by_types.spot[0].parcel_value"
                    model-index="parcel_value"
                    placeholder="R$ 0,00"
                    :model="group.installments_by_types.spot[0]"
                    readonly
                  ></input-currency>
                </d-input-group>
              </d-col>

              <!-- Total -->
              <d-col md="4" cols="12" class="form-group d-flex flex-column">
                <label for="feParcela">Total</label>
                <div class="form-control text-right">{{ addCurrencyMask(group.installments_by_types.spot[0].total) }}</div>
              </d-col>
            </d-form-row>
          </d-card>
        </d-col>
      </d-form-row>

      <!-- If payment type is 7 = "à prazo" -->
      <d-form-row class="justify-content-end" v-if="group.payment_id == 7">
        <d-col lg="9" xl="7" cols="12" class="form-group">
          <d-card class="pb-2">
            <d-card-header>
              <h6 class="m-0">Valores à prazo</h6>
            </d-card-header>
            <d-form-row class="px-3 justify-content-end" v-for="(payment, payment_index) in group.installments_by_types.forward" :key="payment_index">
              <!-- Quantidade de parcelas -->
              <d-col md="3" cols="12" class="form-group mb-0">
                <label for="feEntree">Entrada</label>
                <d-input-group class="mb-2 discount">
                  <d-input-group-addon prepend>
                    <select class="input-group-text form-control custom-select" v-model="payment.entree_type" @change="setParcelValue(payment, index)">
                      <option value="pct" selected>%</option>
                      <option value="value">R$</option>
                    </select>
                  </d-input-group-addon>
                  <input-currency
                    model-index="entree_value"
                    placeholder="Entrada"
                    hiddenGroup=""
                    :parameter="index"
                    :model="payment"
                    :on-change="setParcelValue"
                  ></input-currency>
                </d-input-group>
              </d-col>

              <!-- Quantidade de parcelas -->
              <d-col md="2" cols="12" class="form-group mb-0">
                <label for="fePagto">Parcelas</label>
                <d-form-input
                  type="number"
                  id="fePagto"
                  class="text-right"
                  min="1"
                  v-model="payment.parcel"
                  @input="setParcelValue(payment, index)"
                  @change="setParcelValue(payment, index, true)"
                />
              </d-col>

              <!-- Valor da parcela -->
              <d-col md="3" cols="10" class="form-group mb-0">
                <label for="feParcela">Valor da parcela</label>
                <d-input-group prepend="R$">
                  <input-currency
                    v-if="payment.parcel_value"
                    :key="'fwd-pv-' + index + '-' + payment_index + '-' + payment.parcel_value"
                    model-index="parcel_value"
                    placeholder="R$ 0,00"
                    :model="payment"
                    readonly
                  ></input-currency>
                </d-input-group>
              </d-col>

              <!-- Total -->
              <d-col md="3" cols="10" class="form-group d-flex flex-column">
                <label for="feParcela">Total</label>
                <div class="form-control text-right">{{ addCurrencyMask(payment.total) }}</div>
              </d-col>

              <d-col md="1" cols="2">
                <div class="d-flex justify-content-end align-items-center h-100 pt-4">
                  <i class="fas fa-plus text-success mr-2" @click="addInstallment(index)" v-if="showAddNewInstallment(group.installments_by_types.forward, payment_index)"></i>
                  <i class="fas fa-minus text-danger" @click="removeInstallment(index, payment_index)" v-if="group.installments_by_types.forward.length > 1"></i>
                </div>
              </d-col>
            </d-form-row>
          </d-card>
        </d-col>
      </d-form-row>

      <d-form-row class="justify-content-end">

        <!-- Condição de pagamento -->
        <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
          <label for="fePagto" class="payment-field-label">
            Cond. pagamento
            <button type="button" tabindex="-1" aria-hidden="true" class="btn-primary btn-sm py-1 payment-field-label__spacer">Selecionar</button>
          </label>
          <d-select v-model="group.payment_id" @change="onPaymentConditionChange(index)">
            <option :value="option.id" v-for="(option, index) in paymentTypeOptions" :key="index">{{ option.name }}</option>
          </d-select>
        </d-col>

        <!-- Forma de pagamento -->
        <d-col md="12" lg="12" xl="4" cols="12" class="form-group">
          <label for="fePagtoInfo" class="payment-field-label">
            Forma de pagamento
            <button @click="openObligation('paymentInfo', index)" type="button" class="btn-primary btn-sm py-1">Selecionar</button>
          </label>
          <textarea
            v-model="group.payment_info"
            name="feComentarios"
            rows="5"
            class="form-control"
          ></textarea>
        </d-col>
      </d-form-row>

      <!-- Shipping Company -->
      <d-form-row>

        <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
          <label for="feShippingCOmpany">Transportadora</label>
          <d-form-input type="text" id="feShippingCOmpany" v-model="group.shipping_company" />
        </d-col>

        <!-- Weight -->
        <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
          <label for="feWeight">Peso</label>
          <d-form-input type="text" id="feWeight" class="text-right" min="1" v-model="group.weight" />
        </d-col>

        <!-- Voume -->
        <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
          <label for="feVolume">Volume</label>
          <d-form-input type="text" id="feVolume" class="text-right" min="1" v-model="group.volume" />
        </d-col>

      </d-form-row>

      <d-form-row>

        <!-- Comentários -->
        <d-col md="6" lg="6" cols="12" class="form-group">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
            <label class="mb-0 mr-2">Obrigações contratante</label>
            <div class="d-flex align-items-center">
              <div class="export-visibility" :id="'tooltip-export-buyer-' + index">
                <span>Exibir no PDF</span>
                <d-checkbox
                  toggle
                  :checked="isShownOnExport(group, 'show_obligations_buyer')"
                  @change="toggleExportFlag(group, 'show_obligations_buyer')"
                  class="custom-toggle-sm"
                ></d-checkbox>
              </div>
              <d-tooltip :target="'#tooltip-export-buyer-' + index">
                Quando desligado, as obrigações do contratante deste grupo não aparecem no PDF. O texto continua salvo no orçamento.
              </d-tooltip>
              <button @click="openObligation('contractor', index)" type="button" class="btn-primary btn-sm py-1">Obrigações Contratante</button>
            </div>
          </div>
          <editor :model.sync="group.obligations_buyer" />
        </d-col>

        <!-- Obrigações -->
        <d-col md="6" lg="6" cols="12" class="form-group">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
            <label class="mb-0 mr-2">Obrigações contratado</label>
            <div class="d-flex align-items-center">
              <div class="export-visibility" :id="'tooltip-export-seller-' + index">
                <span>Exibir no PDF</span>
                <d-checkbox
                  toggle
                  :checked="isShownOnExport(group, 'show_obligations_seller')"
                  @change="toggleExportFlag(group, 'show_obligations_seller')"
                  class="custom-toggle-sm"
                ></d-checkbox>
              </div>
              <d-tooltip :target="'#tooltip-export-seller-' + index">
                Quando desligado, as obrigações do contratado deste grupo não aparecem no PDF. O texto continua salvo no orçamento.
              </d-tooltip>
              <button @click="openObligation('hired', index)" type="button" class="btn-primary btn-sm py-1">Obrigações Contratado</button>
            </div>
          </div>
          <editor :model.sync="group.obligations_seller"/>
        </d-col>

      </d-form-row>

      <d-form-row>
        <!-- Itens Inclusos -->
        <d-col cols="12" class="form-group">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
            <label class="mb-0 mr-2">Itens Inclusos</label>
            <div class="d-flex align-items-center">
              <div class="export-visibility" :id="'tooltip-export-items-' + index">
                <span>Exibir no PDF</span>
                <d-checkbox
                  toggle
                  :checked="isShownOnExport(group, 'show_items_included')"
                  @change="toggleExportFlag(group, 'show_items_included')"
                  class="custom-toggle-sm"
                ></d-checkbox>
              </div>
              <d-tooltip :target="'#tooltip-export-items-' + index">
                Quando desligado, os itens inclusos deste grupo não aparecem no PDF. O texto continua salvo no orçamento.
              </d-tooltip>
              <button @click="openObligation('itemsIncluded', index)" type="button" class="btn-primary btn-sm py-1">Itens Inclusos</button>
            </div>
          </div>
          <editor :model.sync="group.items_included" />
        </d-col>
      </d-form-row>

    </d-tab>
  </d-tabs>
</template>

<script>
import draggable from 'vuedraggable';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import CurrencyMask from '_common/mixins/CurrencyMask';
import InputCurrency from '_shared/InputCurrency.vue';
import InputWarranty from '_shared/InputWarranty.vue';
import MixinValidateForm from '_common/mixins/ValidateForm';
import MixinQuotationCalc from '_common/mixins/QuotationCalc';
import GroupActions from './GroupActions.js';
import {
  ROW,
  GROUP,
  PAYMENT,
  PAYMENT_TYPE_OPTIONS,
  PRODUCT_UNITS_OPTIONS,
  _DELETE_TAB_,
  _LOAD_MODEL_,
  _SET_OBLIGATION_IN_QUOTATION_,
  contractItemField,
  MODEL,
  PAYMENT_SPOT,
  PAYMENT_ID_FORWARD,
} from './QuotationModel';
import {
  applyTypeForwardToGroup,
  hasLoadedTypeOptions,
  shouldReapplyDefaultForward,
} from './installmentsPlan';

export default {
  name: 'group-form',
  mixins: [MixinQuotationCalc, MixinValidateForm, CurrencyMask, GroupActions],
  components: {
    Editor,
    draggable,
    Autocomplete,
    InputCurrency,
    InputWarranty,
  },
  props: {
    groups: {
      type: Array,
      default() { return [cloneDeep(GROUP)]; },
    },
    state: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedGroup: 0,
      autoCapitalize: false,
      template: null,
      errors: {
        name: { required: false },
        total: { required: false },
      },
    };
  },
  computed: {
    paymentTypeOptions() {
      return PAYMENT_TYPE_OPTIONS;
    },
    activePriceTable() {
      const { quotation } = this.$store.state.quotation;
      return quotation.service.price_table;
    },
    products() {
      const { productVariationsList } = this.$store.state.product;
      if (productVariationsList && productVariationsList.list.length) {
        return productVariationsList.list;
      }
      return [];
    },
    quotation() {
      const { quotation } = this.$store.state.quotation;
      if (quotation) return quotation;
      return cloneDeep(MODEL);
    },
    quotationTypeId() {
      return this.quotation.type_id;
    },
    typeOptionsFromStore() {
      const { typeOptions } = this.$store.state.quotation;
      if (typeOptions && typeOptions.length) {
        return typeOptions;
      }
      return [];
    },
    productUnits() {
      const { productUnits } = this.$store.state.product;
      if (productUnits && productUnits.length) {
        return productUnits;
      }
      return PRODUCT_UNITS_OPTIONS;
    },
    model: {
      get() {
        return this.groups;
      },
      set(value) {
        this.$emit('update:groups', value);
      },
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getTypeOptions',
      'getProductUnits',
      'getProductVariations',
      'getPaymentTypeOptions',
    ]),
    addRow(index) {
      this.addGroupRow(ROW, index);
      setTimeout(() => {
        this.calcSubtotal(index);
      }, 50);
    },
    checkRequiredFields() {
      let valid = true;
      this.model.forEach(group => {
        Object.keys(group.errors).forEach(field => {
          group.errors[field].required = (group[field] == null);
          valid = group.errors[field].required === true ? false : valid;
        });
        return group;
      });
      return valid;
    },
    addInstallment(index) {
      if (this.model[index].installments_by_types.forward.length < 3) {
        this.model[index].installments_by_types.forward.push(cloneDeep(PAYMENT));
      }
    },
    applyTypeForwardInstallments(groupIndex = null) {
      if (!this.quotationTypeId || !hasLoadedTypeOptions(this.typeOptionsFromStore)) {
        return;
      }

      const indexes = groupIndex != null
        ? [groupIndex]
        : this.model.map((_, index) => index);

      indexes.forEach(index => {
        applyTypeForwardToGroup(
          this.model[index],
          this.typeOptionsFromStore,
          this.quotationTypeId,
        );
        this.setPortionValue(index);
      });
    },
    applyTypeForwardInstallmentsIfDefault() {
      if (!this.quotationTypeId || !hasLoadedTypeOptions(this.typeOptionsFromStore)) {
        return;
      }

      const steps = this.quotation.steps && this.quotation.steps.step;
      const quotationCompleted = !!(steps && steps.quotation && steps.quotation.completed);

      this.model.forEach((group, index) => {
        const forward = group.installments_by_types && group.installments_by_types.forward;
        if (!shouldReapplyDefaultForward(forward, quotationCompleted)) {
          return;
        }
        applyTypeForwardToGroup(
          group,
          this.typeOptionsFromStore,
          this.quotationTypeId,
        );
        this.setPortionValue(index);
      });
    },
    ensureTypeOptionsThenApplyIfDefault() {
      const typeReady = hasLoadedTypeOptions(this.typeOptionsFromStore)
        ? Promise.resolve()
        : this.getTypeOptions();
      return Promise.all([typeReady, this.ensureSettings()]).then(() => {
        this.applyTypeForwardInstallmentsIfDefault();
      });
    },
    onPaymentConditionChange(index) {
      this.calcSubtotal(index);
      this.$nextTick(() => {
        if (Number(this.model[index].payment_id) !== PAYMENT_ID_FORWARD) {
          return;
        }
        this.ensureTypeOptionsThenApply(index);
      });
    },
    addTab() {
      this.addGroupTab(GROUP, 'Novo orçamento');
      this.ensureTypeOptionsThenApply(this.model.length - 1);
    },
    changeStep(item) {
      item.step = 1;
      setTimeout(() => {
        if (item.unit_type === 'm²') {
          item.step = 0.01;
          return item;
        }
        return item;
      }, 50);
    },
    getOptions() {
      if (!this.$store.state.quotation.typeOptions) {
        this.getTypeOptions();
      }
      if (!this.$store.state.quotation.productUnits) {
        this.setToggle({ type: 'progress', bool: true });
        this.getProductUnits()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
      this.getObligationOptions();
    },
    removeRow(groupIndex, index) {
      this.removeGroupRow(groupIndex, index);
      setTimeout(() => {
        this.calcSubtotal(groupIndex);
        this.setProductInAutocomplete();
      }, 50);
    },
    removeInstallment(groupIndex, index) {
      this.model[groupIndex].installments_by_types.forward.splice(index, 1);
    },
    setProductInAutocomplete() {
      setTimeout(() => {
        this.model.map((group, index) => (
          group.rows.map((product, navItemId) => {
            if (this.$refs[`autocompleteProduct_${index}${navItemId}`][0] && product.description) {
              this.$refs[`autocompleteProduct_${index}${navItemId}`][0].$refs.input.value = product.description;
            }
            return product;
          })
        ));
      }, 20);
    },
    setDescriptionQuotationRow(value, { item }) {
      if (item.variation_id === null) {
        item.description = value;
      }
    },
    setProductQuotationRow(product, { item, index }) {
      const productHasImage = !!(product.image_id || (product.image && product.image.id));
      const shouldResetShowImage = item.variation_id !== product.id || !productHasImage;

      item.description = product.name;
      item.warranty_period = product.warranty_period;
      item.warranty_type = product.warranty_type;
      item.variation_id = product.id;
      item.value = product.price;
      item.unit_type = product.unit_type;
      item.variation = product;
      if (shouldResetShowImage) {
        this.$set(item, 'show_image', false);
      }
      this.setTotal(item, index);
    },
    hasProductImage(item) {
      const { variation } = item;
      if (!variation) return false;
      return !!(variation.image_id || (variation.image && variation.image.id));
    },
    rowsWithProductImage(group) {
      return (group.rows || []).filter(item => this.hasProductImage(item));
    },
    hasAnyProductImage(group) {
      return this.rowsWithProductImage(group).length > 0;
    },
    areAllShowImagesEnabled(group) {
      const rows = this.rowsWithProductImage(group);
      return rows.length > 0 && rows.every(item => item.show_image);
    },
    toggleShowImage(item) {
      this.$set(item, 'show_image', !item.show_image);
    },
    toggleAllShowImages(group) {
      const rows = this.rowsWithProductImage(group);
      if (!rows.length) return;
      const enable = !this.areAllShowImagesEnabled(group);
      rows.forEach(item => {
        this.$set(item, 'show_image', enable);
      });
    },
    showAddNewInstallment(installments, index) {
      const { length } = installments;
      if (length < 3 && index + 1 === length) {
        return true;
      }
      return false;
    },
    openObligation(type, index) {
      this.openContractItemSelect(type, index, this.model[index]);
    },
    isShownOnExport(group, field) {
      const value = group[field];
      if (value === false || value === 0 || value === '0') return false;
      return true;
    },
    toggleExportFlag(group, field) {
      this.$set(group, field, !this.isShownOnExport(group, field));
    },
    ensureExportFlags() {
      if (!Array.isArray(this.model)) return;
      this.model.forEach(group => {
        ['show_obligations_buyer', 'show_obligations_seller', 'show_items_included'].forEach(field => {
          this.$set(group, field, this.isShownOnExport(group, field));
        });
      });
    },
    togglePaymentSpot(index) {
      this.model[index].payment_spot = this.model[index].payment_spot === 1 ? 0 : 1;
      this.model[index].installments_by_types = {
        ...this.model[index].installments_by_types,
        ...{
          spot: [cloneDeep(PAYMENT_SPOT)],
        },
      };
      this.setQuotationTotal(null, index);
    },
    recalculateAfterTemplateApply() {
      this.ensureExportFlags();
      this.ensureRowShowImage();
      this.model.forEach((group, index) => {
        this.calcSubtotal(index);
        this.setPortionValue(index);
      });
      this.updateTabs();
      this.setProductInAutocomplete();
    },
    onLoadModel() {
      this.loadModel();
      this.ensureExportFlags();
      this.ensureTypeOptionsThenApplyIfDefault();
    },
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
    Events.$off(_DELETE_TAB_);
    Events.$off(_SET_OBLIGATION_IN_QUOTATION_);
  },
  mounted() {
    this.getOptions();
    this.onLoadModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.onLoadModel();
    });
    Events.$on(_DELETE_TAB_, index => {
      this.deleteTab(index);
    });
    Events.$on(_SET_OBLIGATION_IN_QUOTATION_, ({ obligation, type, index }) => {
      this.model[index][contractItemField(type)] = obligation;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.export-visibility {
  display: inline-flex;
  align-items: center;
  margin-right: 0.75rem;
  color: #5a6169;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;

  > span {
    margin-right: 0.35rem;
  }

  ::v-deep .custom-toggle.custom-toggle-sm {
    min-height: 0.9rem;
    margin: 0;
    padding-left: 1.9rem;
    line-height: 1;

    .custom-control-label {
      min-height: 0.9rem;
      margin-bottom: 0;
      line-height: 1;

      &::before {
        top: 0;
        width: 1.65rem;
        height: 0.9rem;
      }

      &::after {
        top: 0.15rem;
        left: 0.15rem;
        width: 0.6rem;
        height: 0.6rem;
      }
    }

    .custom-control-input:checked ~ .custom-control-label::after {
      left: calc(1.65rem - 0.0625rem - 0.15rem);
    }
  }
}

.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}
.groups-tab ::v-deep  .nav-tabs {
  border-bottom: 0!important;
}
.tab-pane {
  border: 1px solid #e1e5eb;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.td {
  &-1 {
    width: 4%;
  }
  &-2 {
    width: 10%;
    min-width: 75px;
  }
  &-3 {
    width: 15%;
  }
  &-4 {
    width: 35%;
  }
  &-presentation {
    width: 6%;
    min-width: 70px;
    text-align: center;
    vertical-align: middle;
  }
}

.th-presentation,
.td-presentation {
  ::v-deep .custom-toggle {
    display: inline-flex;

    &.custom-toggle-disabled {
      opacity: 0.45;
    }
  }
}

.th-show-image-toggle {
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  line-height: 1;
  cursor: pointer;
  opacity: 0.55;
  font-size: 0.95em;
  transition: opacity 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &.is-active {
    opacity: 1;
    color: #28a745;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
}
.buttons {
  text-align: center;
  vertical-align: bottom;
  .btn-sm { padding: 0.4rem 0.7rem; }
  i { cursor: pointer; }
}

.payment-field-label {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  &__spacer {
    flex: 0 0 0;
    width: 0;
    min-width: 0;
    margin: 0;
    padding-left: 0 !important;
    padding-right: 0 !important;
    overflow: hidden;
    visibility: hidden;
    white-space: nowrap;
    border-left-width: 0;
    border-right-width: 0;
    pointer-events: none;

    @media (max-width: 1199.98px) {
      display: none;
    }
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

@media only screen
  and (max-width: 760px), (min-device-width: 768px)
  and (max-device-width: 1024px)  {

  /* Force table to not be like tables anymore */
  table, thead, tbody, th, td, tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin: 0;
    &:nth-child(odd) {
      background: #ccc;
    }
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    vertical-align: middle;
    padding-top: 30px;
    &:first-child {
      text-align: center;
      padding: 3px 3px 9px 3px;
      &:before {
        position: absolute;
        top: 10px;
        left: 116px;
        width: 5%;
        padding-right: 10px;
        white-space: nowrap;
      }
    }
    &:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 5px;
      left: 6px;
      width: 5%;
      padding-right: 10px;
      white-space: nowrap;
    }
    &.td-1,
    &.td-2,
    &.td-3,
    &.td-4,
    &.td-presentation {
      width: 100%;
    }
    &.buttons {
      i {
        padding: 10px;
        color: #fff !important;
        border-radius: 5px;
        &.fa-minus{
          border: 1px solid #c4183c;
          background: #dc3545;
        }
        &.fa-plus {
          margin-right: 5px;
          border: 1px solid #28a745;
          background: #17c671;
        }

      }
    }
  }

  /*
  Label the data
  You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
  */
  td:nth-of-type(1):before { content: "ID"; }
  td:nth-of-type(2):before { content: "Descrição produto"; }
  td:nth-of-type(3):before { content: "Img."; }
  td:nth-of-type(4):before { content: "Garantia"; }
  td:nth-of-type(5):before { content: "Unid."; }
  td:nth-of-type(6):before { content: "Qtd."; }
  td:nth-of-type(7):before { content: "Valor un."; }
  td:nth-of-type(8):before { content: "Total"; }
  td:nth-of-type(9):before { content: "Op\00e7\00f5""es"; }
}

</style>
